import React, { Component } from 'react';
// import AutosuggestComponent from '../../../../Utility/Components/AutosuggestComponent';
// import OrganizationModalContent from '../Organization/Components/OrganizationModalContent'
import AccountInfoContent from './Components/AccountInfoContent';
import { useTranslation, withTranslation, Trans } from 'react-i18next';

import { AgGridReact } from '@ag-grid-community/react';
import { InfiniteRowModelModule } from '@ag-grid-community/infinite-row-model';
import '@ag-grid-community/styles/ag-grid.css';
import '@ag-grid-community/styles/ag-theme-alpine.css';
import * as AccountInfoController from './Controller/AccountInfoController';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import ConfirmationAlert from '../../../Utility/Components/ConfirmationAlert';
import { loaderStateTrue, loaderStateFalse } from '../../../Actions/AllAction';
import { setToken, setUserCredentials, logOutApp } from '../../../GlobalModules/Login/Actions/LoginAction';
import CustomInput from '../../../Utility/Components/CustomInput';
import Utility from '../../../Utility/Utility';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import ModalGlobal from '../../../Utility/Components/ModalGlobal'
import HomeUtility from '../../Utility/Utility'
import moment from 'moment-timezone';
import Config from '../../../Utility/Config';
import GridActionContent from '../../../Utility/Components/GridActionContent'
import BootstrapSwitchButton from 'bootstrap-switch-button-react';
import GlobalHeaderFilter from '../../../Utility/Components/GlobalHeaderFilter';
import OrganisationFilterContent from '../../../Utility/Components/OrganisationFilterContent';
import ErrorBoundary from '../../../Utility/Components/ErrorBoundary';
import CustomButton from '../../../Utility/Components/CustomButton'
import axios from 'axios';
import './Assets/css/accountinfo_doc.scss'
import Timezone from '../../../Utility/Timezone';


class AccountInfo extends Component {
    constructor(props) {
        super(props);
        this.state = {
            //Org img add
            addProfileImagePreviewShow: false,
            addprofileImageSelected: require('../../../Utility/Public/images/uploadicon.png'),
            addProfileImageError: "",

            // User Image Add
            addUserImagePreviewShow: false,
            addUserImageSelected: require('../../../Utility/Public/images/profile-back.png'),
            addUserImageError: "",

            //IMage crop
            src: null,
            crop: {
                unit: '%',
                width: 30,
                aspect: 1 / 1
            },
            croppedImageUrl: "",

            imageCropModalFlag: false,
            valueEdited: false,
            fromData: {
                "organization_name": "",
                "profileImage": "",
                "org_id": "",
                "whatsapp_api_endpoint": "",
                "phone_number_id": "",
                "token": "",
                "marketed_by_name": "",
                "marketed_by_url": "",
                "selectedVersion": [],
                "contractStartDate": "",
                "contractEndDate": "",
                "whatsapp_business_account_id": "",
                "facebook_app_id": "",
                "delay_time": "0.00",
                "secret_key": ""
            },
            fromDataError: {
                "organization_name": "",
                "whatsapp_api_endpoint": "",
                "phone_number_id": "",
                "token": "",
                "marketed_by_name": "",
                "marketed_by_url": "",
                "selectedVersion": "",
                "contractStartDate": "",
                "contractEndDate": "",
                "whatsapp_business_account_id": "",
                "facebook_app_id": "",
                "delay_time": "",
                "secret_key": ""
            },
            statusList: [{ label: "Active", value: "Active" }, { label: "Inactive", value: "Inactive" }],
            actionModalflag: false,
            deleteConfirmationAlertModal: false,
            gridObjData: "",
            addUserModalFlag: false,

            //Add User From Data
            addUserFromData: {
                "name": "",
                "email": "",
                //"phone": "",
                //"address": "",
                "profileImage": "",
                "status": true,
                "user_id": "",
            },

            addUserFromDataError: {
                "name": "",
                "email": ""
            },
            addUserInfoFromData: {
                "city": "",
                "country": "",
                "phone_no": "",
            },
            addUserInfoFromDataError: {
                "city": "",
                "country": "",
                "phone_no": "",
            },

            //orgDataEditFlag: false,
            userDataEditFlag: false,
            imageEditFrom: "",
            deleteButtonEnableFlagForGridActionContent: false,

            deleteUserConfirmationAlertModal: false,
            userDeleteBodySecondContent: "",
            userDeleteObj: "",
            orgAddEditModalTitle: "",
            orgName: "",
            //saveButtonDisableEditModal: true,

            //file upload
            documentObjFileName: this.props.t('choosefile'),
            documentObjfileObj: "",
            documentError: "",
            versionOption: this.props.version,
            handleChangeVersionFlag: false,

            freeTrialSubscription: false,
            monthlySubscription: false,
            yearlySubscription: false,
            zoominzoomoutflag: "",

            // handleChangeUserInformationPhoneNumberFlag: false,
            whatsappBusinessPhoneNumberError: "",
            whatsappBusinessPhoneNumber: "",
            whatsappBusinessPhoneNumberNote: false,
            totalDatasetCount: 0,
        }
    }

    componentDidMount() {
        this.fetchAccountInfo();
    }

    fetchAccountInfo() {
        const { loaderStateTrue, loaderStateFalse } = this.props;
        loaderStateTrue();
        let filters = {};
        let globalQueryParamshash = {};

        globalQueryParamshash["offset"] = 0;
        globalQueryParamshash["limit"] = 20;

        filters['filters'] = JSON.stringify(globalQueryParamshash)
        AccountInfoController.orgListing(filters).then((response) => {
            if (response.success) {
                let promiseArr = []
                response.data.map((item, index) => {
                    let promise = new Promise((resolve, reject) => {
                        this.logoImageUi(item.id).then((data) => {
                            item["profile_img_temp"] = data;
                            resolve(item)
                        })

                    })
                    promiseArr.push(promise)
                })
                Promise.all(promiseArr).then((values) => {
                    // console.log("values==========>", values)
                    this.setState({
                        gridObjData: values[0]
                    }, () => {
                        this.setSubscriptionValue();
                        this.setEditData();
                    })
                });
            } else {
                Utility.toastNotifications("Something went wrong !", "Error", "error")
            }
            loaderStateFalse();
        }).catch((error) => {
            //console.error("************error*************", error)
            loaderStateFalse();
        });
    }

    logoImageUi = (id) => {
        const promise = new Promise((resolve, reject) => {
            const { loaderStateTrue, loaderStateFalse } = this.props;
            loaderStateTrue();
            let data = {};
            data["filters"] = JSON.stringify(Config.thumbnailSize)
            AccountInfoController.orgDetails(id, data).then((response) => {
                if (response.success) {
                    // console.log("response.data[0]========", response.data[0].user_details)
                    let responseUserDetails = response.data[0].logo_img;
                    if (responseUserDetails && Object.keys(responseUserDetails).length > 0) {
                        resolve(responseUserDetails.file_obj)
                    } else {
                        resolve(require('../../../Utility/Public/images/usericon.png'))
                    }
                }
                loaderStateFalse();
            }).catch((error) => {
                //console.error("************error*************", error)
                if (error) {
                    //Utility.toastNotifications(error.message, "Error", "error");
                }
                loaderStateFalse();
                if (error.message == "Network Error") {
                    /*Utility.toastNotifications("Please login", "Error", "error");
                    this.props.logOutApp().then(
                        () => this.props.history.push("/")
                    );*/
                }
            });
        })
        return promise;
    }

    setEditData = () => {
        const { gridObjData, addUserFromData, addUserInfoFromData } = this.state;
        let addUserFromDataTemp = Object.assign({}, addUserFromData);
        let addUserInfoFromDataTemp = Object.assign({}, addUserInfoFromData);
        //let marketedLogo = JSON.parse(gridObjData?.data?.marketed_by_logo_url)?.file_name

        // let marketedLogo = gridObjData.marketed_by_logo_url != null && JSON.parse(gridObjData.marketed_by_logo_url).hasOwnProperty("file_name") ? JSON.parse(gridObjData?.data?.marketed_by_logo_url)?.file_name : this.props.t('choosefile');
        let marketedLogo = gridObjData.marketed_by_logo_url != null && JSON.parse(gridObjData.marketed_by_logo_url).hasOwnProperty("file_name") ? JSON.parse(gridObjData?.marketed_by_logo_url)?.file_name : this.props.t('choosefile');

        let version = gridObjData.version_id != null ? gridObjData.version_id : "";
        let tempOptionData = this.state.versionOption.slice();
        let objectWithKeyA = this.findObjectByKey(tempOptionData, 'value', version);
        let selectedVerionArray = [];
        if (objectWithKeyA != null) {
            selectedVerionArray.push(objectWithKeyA)
        } else {
            this.setState({ "selectedVersion": selectedVerionArray }, () => { })
        }

        var formattedStartContractDate = "";
        if (gridObjData.hasOwnProperty('contract_start_date') && gridObjData.contract_start_date != "" && gridObjData.contract_start_date != null) {
            let tempcontract_start_date = new Date(gridObjData.contract_start_date);
            formattedStartContractDate = {
                year: tempcontract_start_date.getFullYear(),
                month: tempcontract_start_date.getMonth() + 1,
                day: tempcontract_start_date.getDate(),
            }
        }

        var formattedEndContractDate = "";
        if (gridObjData.hasOwnProperty('contract_end_date') && gridObjData.contract_end_date != "" && gridObjData.contract_end_date != null) {
            let tempcontract_end_date = new Date(gridObjData.contract_end_date);
            formattedEndContractDate = {
                year: tempcontract_end_date.getFullYear(),
                month: tempcontract_end_date.getMonth() + 1,
                day: tempcontract_end_date.getDate(),
            }
        }

        if (gridObjData.hasOwnProperty('name') && gridObjData.name == gridObjData.name) {
            this.setState({
                valueEdited: false
            })
        }

        this.setState({
            fromData: {
                "organization_name": gridObjData.name,
                "whatsapp_api_endpoint": gridObjData.whatsapp_api_endpoint,
                "phone_number_id": gridObjData.phone_number_id,
                "token": gridObjData.token,
                "marketed_by_name": gridObjData.marketed_by_name,
                "marketed_by_url": gridObjData.marketed_by_url,
                "profileImage": "",
                "org_id": gridObjData.id,
                "selectedVersion": selectedVerionArray,
                "contractStartDate": formattedStartContractDate,
                "contractEndDate": formattedEndContractDate,
                "facebook_app_id": gridObjData.facebook_app_id,
                "whatsapp_business_account_id": gridObjData.whatsapp_business_account_id,
                "delay_time": gridObjData.delay_time,
                "secret_key": gridObjData.secret_key
            },
            addProfileImagePreviewShow: true,
            addprofileImageSelected: gridObjData.profile_img_temp,
            //documentObjFileName: JSON.parse(gridObjData.marketed_by_logo_url).file_name
            documentObjFileName: marketedLogo,
            whatsappBusinessPhoneNumber: gridObjData.whatsapp_business_phone_number

        }, () => {
            //console.log("documentObjFileName===========", this.documentObjFileName)
            // if (gridObjData.admins.length > 0) {
            //     addUserFromDataTemp = {
            //         "name": gridObjData.admins[0].user_name,
            //         "email": gridObjData.admins[0].user_email,
            //         //"phone": gridObjData.admins[0].user_ph_no,
            //         //"address": gridObjData.admins[0].address,
            //         "profileImage": "",
            //         "status": gridObjData.admins[0].status,
            //         "user_id": gridObjData.admins[0].id,
            //     }

            //     addUserInfoFromDataTemp = {
            //         "city": gridObjData?.data?.admins[0]?.personal_information?.city,
            //         "country": gridObjData?.data?.admins[0]?.personal_information?.country,
            //         "phone_no": gridObjData?.data?.admins[0]?.personal_information?.phone_no,
            //     },

            //         this.setState({
            //             addUserFromData: addUserFromDataTemp,
            //             addUserImagePreviewShow: true,
            //             addUserImageSelected: gridObjData.admins[0].user_profile_img_temp,
            //             addUserInfoFromData: addUserInfoFromDataTemp
            //         }, () => {
            //             //console.log("addUserInfoFromData================1", this.state.addUserInfoFromData)
            //         })
            // } else {
            addUserFromDataTemp = {
                "name": "",
                "email": "",
                //"phone": "",
                //"address": "",
                "profileImage": "",
                "status": "",
                "user_id": ""
            }
            addUserInfoFromDataTemp = {
                "city": "",
                "country": "",
                "phone_no": "",
            },

                this.setState({
                    addUserFromData: addUserFromDataTemp,
                    addUserImagePreviewShow: false,
                    addUserImageSelected: "",
                    addUserInfoFromData: addUserInfoFromDataTemp
                }, () => {
                    //console.log("addUserImageSelected", this.state.addUserImageSelected)
                })
            // }
        })
    }

    setSubscriptionValue = () => {
        const { gridObjData } = this.state;
        const diff = Utility.checkDateDiff(gridObjData.contract_start_date, gridObjData.contract_end_date)
        if (diff == 'Y') {
            this.setState({
                yearlySubscription: true,
                monthlySubscription: false,
                freeTrialSubscription: false,
            })
        } else if (diff == 'M') {
            this.setState({
                yearlySubscription: false,
                monthlySubscription: true,
                freeTrialSubscription: false,
            })
        } else {
            this.setState({
                yearlySubscription: false,
                monthlySubscription: false,
                freeTrialSubscription: true,
            })
        }
    }

    findObjectByKey = (array, key, value) => {
        for (let i = 0; i < array.length; i++) {
            if (array[i][key] === value) {
                return array[i];
            }
        }
        return null; // Object not found
    }

    handelChange = (event, type) => {
        let fromDataTemp = Object.assign({}, this.state.fromData);
        let fromDataTempError = Object.assign({}, this.state.fromDataError);
        if (type == "organization_name") {
            var expr = /^[a-zA-Z0-9 ]*$/;
            if (!expr.test(event.target.value)) {
                // fromDataTempError['organization_name'] = "Only allow characters"
            } else {
                if (event.target.value != "") {
                    fromDataTemp['organization_name'] = event.target.value;
                    fromDataTempError['organization_name'] = "";
                    this.setState({
                        valueEdited: true
                    })
                } else {
                    fromDataTemp['organization_name'] = "";
                    //fromDataTempError['organization_name'] = "Required field"
                }
            }

        }

        if (type == "whatsapp_api_endpoint") {
            if (event.target.value != "") {
                fromDataTemp['whatsapp_api_endpoint'] = event.target.value;
                fromDataTempError['whatsapp_api_endpoint'] = ""
            } else {
                fromDataTemp['whatsapp_api_endpoint'] = "";
                //fromDataTempError['whatsapp_api_endpoint'] = "Required field"
            }
        }
        if (type == "delay_time") {
            if (event.target.value != "") {
                fromDataTemp['delay_time'] = event.target.value;
                fromDataTempError['delay_time'] = ""
            } else {
                fromDataTemp['delay_time'] = "";
                //fromDataTempError['delay_time'] = "Required field"
            }
        }
        if (type == "phone_number_id") {
            if (event.target.value != "") {
                fromDataTemp['phone_number_id'] = event.target.value;
                fromDataTempError['phone_number_id'] = ""
            } else {
                fromDataTemp['phone_number_id'] = "";
                //fromDataTempError['phone_number_id'] = "Required field"
            }
        }
        if (type == "token") {
            if (event.target.value != "") {
                fromDataTemp['token'] = event.target.value;
                fromDataTempError['token'] = ""
            } else {
                fromDataTemp['token'] = "";
                // fromDataTempError['token'] = "Required field"
            }
        }
        if (type == "marketed_by_name") {
            if (event.target.value != "") {
                fromDataTemp['marketed_by_name'] = event.target.value;
                fromDataTempError['marketed_by_name'] = ""
            } else {
                fromDataTemp['marketed_by_name'] = "";
                //fromDataTempError['marketed_by_name'] = "Required field"
            }
        }
        if (type == "marketed_by_url") {
            if (event.target.value != "") {
                fromDataTemp['marketed_by_url'] = event.target.value;
                fromDataTempError['marketed_by_url'] = ""
            } else {
                fromDataTemp['marketed_by_url'] = "";
                //fromDataTempError['marketed_by_url'] = "Required field"
            }
        }

        if (type == "facebook_app_id") {
            if (event.target.value != "") {
                fromDataTemp['facebook_app_id'] = event.target.value;
                fromDataTempError['facebook_app_id'] = ""
            } else {
                fromDataTemp['facebook_app_id'] = "";
                //fromDataTempError['facebook_app_id'] = "Required field"
            }
        }

        if (type == "whatsapp_business_account_id") {
            if (event.target.value != "") {
                fromDataTemp['whatsapp_business_account_id'] = event.target.value;
                fromDataTempError['whatsapp_business_account_id'] = ""
            } else {
                fromDataTemp['whatsapp_business_account_id'] = "";
                //fromDataTempError['whatsapp_business_account_id'] = "Required field"
            }
        }

        this.setState({
            fromData: fromDataTemp,
            fromDataError: fromDataTempError,
            //orgDataEditFlag: true,
            //saveButtonDisableEditModal: false
        }, () => {
            //console.log("fromData=========", this.state.fromData)
        })


    }

    addCustomer = () => {
        const { orgDataEditFlag, userDataEditFlag } = this.state
        // console.log('orgDataEditFlag---------------->',orgDataEditFlag)
        // if (orgDataEditFlag) {
        this.addEditOrganizationData()
        // }
        if (userDataEditFlag) {
            this.addEditUser()
        }

    }

    addEditOrganizationData = () => {
        let valid = this.validCustomerData();
        // console.log('Edit-----Edit-------->')
        // console.log('valid------------->', valid)
        if (valid) {
            let dataSet = this.formatingFormData();
            const { loaderStateTrue, loaderStateFalse } = this.props;
            const { fromData } = this.state;
            loaderStateTrue();
            let type = "post";
            let id = ""
            if (fromData.org_id != "") {
                id = fromData.org_id,
                    type = "patch";
                dataSet = dataSet[0]
            }
            //console.log("dataSet=========",dataSet)
            // return false;
            AccountInfoController.orgCreate(dataSet, id, type).then((response) => {
                //console.log("response=====", response)
                loaderStateFalse();

                if (type == 'post') {

                    if (response.length > 0) {
                        response.map((res, index) => {
                            if (res.success) {
                                this.closeOrganizationModal();
                                // this.resetDataGrid();
                                Utility.toastNotifications(res.message, "Success", "success");
                            } else {
                                Utility.toastNotifications(res.message, "Error", "error")
                            }
                        })
                    }
                } else {
                    if (response.success) {
                        //alert("addEditOrganizationData patch")
                        this.closeOrganizationModal();
                        this.setState({
                            valueEdited: false
                        })
                        // this.resetDataGrid();
                        Utility.toastNotifications(response.message, "Success", "success");

                    } else {
                        Utility.toastNotifications(response.message, "Error", "error")
                    }
                }
                // this.setState({
                //     documentObjfileObj: "",
                //     documentObjFileName: this.props.t('choosefile'),

                // })

            }).catch((error) => {
                console.error("************error*************", error)
                if (error) {
                    //Utility.toastNotifications(error.message, "Error", "error");
                }
                loaderStateFalse();
                if (error.message == "Network Error") {
                    // Utility.toastNotifications("Please login", "Error", "error");
                    // this.props.logOutApp().then(
                    //     () => this.props.history.push("/")
                    // );
                }
            });

        }
    }

    formatingFormData = () => {
        const { fromData, documentObjfileObj, whatsappBusinessPhoneNumber } = this.state;
        let dataSet = [];
        let hash = {};
        hash['name'] = fromData.organization_name.trim()
        hash['delay_time'] = fromData.delay_time
        hash['whatsapp_api_endpoint'] = fromData.whatsapp_api_endpoint
        hash['phone_number_id'] = fromData.phone_number_id
        hash['token'] = fromData.token
        hash['marketed_by_name'] = fromData.marketed_by_name
        hash['marketed_by_url'] = fromData.marketed_by_url
        hash['whatsapp_business_phone_number'] = whatsappBusinessPhoneNumber;
        // console.log('fromData.contractStartDate;==============>', fromData.contractStartDate)
        // console.log('fromData.contractEndDate;==============>', fromData.contractEndDate)

        // "2023-07-06"
        hash['contract_start_date'] = `${fromData.contractStartDate.year}-${(fromData.contractStartDate.month).toString().padStart(2, 0)}-${(fromData.contractStartDate.day).toString().padStart(2, 0)}`;
        hash['contract_end_date'] = `${fromData.contractEndDate.year}-${(fromData.contractEndDate.month).toString().padStart(2, 0)}-${(fromData.contractEndDate.day).toString().padStart(2, 0)}`;
        let versionList = this.props.version;
        let selectedVersion = versionList.filter((e) => e.label == fromData.selectedVersion[0].label);
        hash['version_id'] = selectedVersion[0].value;
        hash['facebook_app_id'] = fromData.facebook_app_id;
        hash['whatsapp_business_account_id'] = fromData.whatsapp_business_account_id;

        if (Object.keys(fromData.profileImage).length > 0) {
            hash['logo_img'] = fromData.profileImage
        }
        if (Object.keys(documentObjfileObj).length > 0) {
            hash['marketed_by_logo_url'] = documentObjfileObj
        }
        hash['id'] = fromData.id

        dataSet.push(hash);
        // console.log("dataSet=========", dataSet)
        return dataSet;

    }

    validCustomerData = () => {
        let fromDataTemp = Object.assign({}, this.state.fromData);
        let fromDataTempError = Object.assign({}, this.state.fromDataError);
        let valid = true;

        if (fromDataTemp.organization_name.trim() == "") {
            fromDataTempError['organization_name'] = "Required field";
            valid = false;
        } else {
            fromDataTempError['organization_name'] = ""
        }

        if (fromDataTemp.whatsapp_api_endpoint == "") {
            fromDataTempError['whatsapp_api_endpoint'] = "Required field";
            valid = false;
        } else {
            fromDataTempError['whatsapp_api_endpoint'] = ""
        }

        if (fromDataTemp.phone_number_id == "") {
            fromDataTempError['phone_number_id'] = "Required field";
            valid = false;
        } else {
            fromDataTempError['phone_number_id'] = ""
        }

        if (fromDataTemp.delay_time == "") {
            fromDataTempError['delay_time'] = "Required field";
            valid = false;
        } else {
            fromDataTempError['delay_time'] = ""
        }

        if (fromDataTemp.token == "") {
            fromDataTempError['token'] = "Required field";
            valid = false;
        } else {
            fromDataTempError['token'] = ""
        }
        if (fromDataTemp.selectedVersion.length == 0) {
            fromDataTempError['selectedVersion'] = "Required field";
            valid = false;
        } else {
            fromDataTempError['selectedVersion'] = ""
        }
        if (fromDataTemp.contractStartDate == "") {
            fromDataTempError['contractStartDate'] = "Required field";
            valid = false;
        } else {
            fromDataTempError['contractStartDate'] = ""
        }
        if (fromDataTemp.contractEndDate == "") {
            fromDataTempError['contractEndDate'] = "Required field";
            valid = false;
        } else {
            fromDataTempError['contractEndDate'] = ""
        }

        if (this.state.whatsappBusinessPhoneNumber == "") {
            this.setState({
                whatsappBusinessPhoneNumberError: 'Required field'
            })
            valid = false;
        } else {
            // console.log("this.state.phoneNumber--------------//////------->",this.state.phoneNumber)
            let phoneNumberValidCheck = HomeUtility.validate_Phone_Number_without_plus(Config.phoneNumberWithOrwithoutPlus + this.state.whatsappBusinessPhoneNumber)
            // console.log("phoneNumberValidCheck-------------->", phoneNumberValidCheck)
            if (phoneNumberValidCheck) {
                this.setState({
                    whatsappBusinessPhoneNumberError: ''
                })
            } else {
                this.setState({
                    whatsappBusinessPhoneNumberError: 'Enter valid phone number'
                })
                valid = false;
            }
        }

        if (fromDataTemp.facebook_app_id == "") {
            fromDataTempError['facebook_app_id'] = "Required field";
            valid = false;
        } else {
            fromDataTempError['facebook_app_id'] = ""
        }

        if (fromDataTemp.whatsapp_business_account_id == "") {
            fromDataTempError['whatsapp_business_account_id'] = "Required field";
            valid = false;
        } else {
            fromDataTempError['whatsapp_business_account_id'] = ""
        }

        this.setState({
            fromDataError: fromDataTempError
        })
        return valid;

    }

    addEditUser = () => {
        let valid = this.validAddUserData();
        // console.log('Edit--------->')
        const { loaderStateTrue, loaderStateFalse } = this.props;
        const { addUserFromData, gridObjData } = this.state;

        if (valid) {
            let data = this.formatingUserData();

            let method = 'post';
            let id = ""
            let addUserDataSet = [data.add];

            if (addUserFromData.user_id != "") {
                id = addUserFromData.user_id,
                    method = "patch";
                addUserDataSet = data.update;
            }
            //return false;
            loaderStateTrue();
            AccountInfoController.addUser(addUserDataSet, method, id).then((response) => {
                loaderStateFalse();
                if (method == 'post') {
                    if (response[0].success) {
                        this.orgCustRelation(response[0].data[0].id).then((orgCustRelationResponse) => {
                            if (orgCustRelationResponse) {
                                this.closeUserModal()
                                this.closeOrganizationModal()
                                // this.resetDataGrid()
                                Utility.toastNotifications(response[0].message, "Success", "success");
                            }
                        })
                        this.adminUsersInfo(response[0].data[0].id, response[0].data[0].user_number, "newCreate")
                    } else {
                        Utility.toastNotifications(response[0].message, "Error", "error");
                    }
                } else {
                    if (response.success) {
                        if (gridObjData?.data?.admins?.length > 0) {
                            //let userNumber = gridObjData?.data?.admins[0]?.user_number
                            let userId = gridObjData?.data?.admins[0]?.personal_information?.user_id
                            //this.adminUsersInfo(userId, userNumber, "alreadyCreated")
                            this.adminUsersInfo(userId, null, "alreadyCreated")
                        }

                        // this.closeUserModal()
                        this.closeOrganizationModal()
                        // this.resetDataGrid()
                        Utility.toastNotifications(response.message, "Success", "success");
                    } else {
                        Utility.toastNotifications(response.message, "Error", "error");
                    }

                }
            }).catch((error) => {
                //console.error("************error*************", error)
                //console.log("error============", error)
                if (error) {
                    //Utility.toastNotifications(error.message, "Error", "error");
                }
                loaderStateFalse();
                if (error.message == "Network Error") {
                    // Utility.toastNotifications("Please login", "Error", "error");
                    // this.props.logOutApp().then(
                    //     () => this.props.history.push("/")
                    // );
                }
                if (error.response.status == 409) {
                    Utility.toastNotifications(error.response.data.message, "Error", "error");
                }
            });

        }
    }

    validAddUserData = () => {
        const { addUserFromData, addUserFromDataError, addUserImageError, addUserInfoFromData, addUserInfoFromDataError } = this.state;
        let tempAddUserFromDataError = Object.assign({}, addUserFromDataError)
        let tempAddUserInfoFromDataError = Object.assign({}, addUserInfoFromDataError);

        let valid = true;
        if (addUserFromData.name == "") {
            tempAddUserFromDataError['name'] = "Required field"
            valid = false;
        } else {
            tempAddUserFromDataError['name'] = ""
        }

        if (addUserFromData.email == "") {
            tempAddUserFromDataError['email'] = "Required field"
            valid = false;
        } else {
            var expr = /^([\w-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/;
            if (!expr.test(addUserFromData.email)) {
                tempAddUserFromDataError['email'] = "Enter valid email"
                valid = false;
            } else {
                tempAddUserFromDataError['email'] = ""
            }

        }

        if (addUserImageError != "") {
            valid = false;
        }

        let phoneValidate = HomeUtility.validate_Phone_Number(addUserInfoFromData.phone_no);
        if (addUserInfoFromData.phone_no != "") {
            if (phoneValidate) {
                tempAddUserInfoFromDataError['phone_no'] = ""
            } else {
                tempAddUserInfoFromDataError['phone_no'] = "Enter correct phone number"
                valid = false;
            }
        }
        /*if(!valid){
            return false
        }*/

        this.setState({
            addUserFromDataError: tempAddUserFromDataError,
            addUserInfoFromDataError: tempAddUserInfoFromDataError,
        })

        return valid;
    }

    formatingUserData = () => {
        const { addUserFromData } = this.state;
        //console.log("addUserFromData==>>", addUserFromData)
        let tempHash = {};
        tempHash["add"] = {}
        tempHash["update"] = {}
        if (addUserFromData.user_id == "") {
            tempHash["add"]['name'] = addUserFromData.name != "" ? addUserFromData.name : "";
            tempHash["add"]['email'] = addUserFromData.email != "" ? addUserFromData.email : "";
            tempHash["add"]['type'] = "admin";
            //tempHash["add"]['phone_no'] = addUserFromData.phone != "" ? addUserFromData.phone : "";
            //tempHash["add"]['address'] = addUserFromData.address != "" ? addUserFromData.address.toString() : "";
            tempHash["add"]['status'] = addUserFromData.status ? 1 : 0;
            if (Object.keys(addUserFromData.profileImage).length > 0) {
                tempHash["add"]['profile_img'] = addUserFromData.profileImage
            }
        } else {
            tempHash["update"]['name'] = addUserFromData.name != "" ? addUserFromData.name : "";
            tempHash["update"]['email'] = addUserFromData.email != "" ? addUserFromData.email : "";
            tempHash["update"]['type'] = "admin";
            //tempHash["update"]['phone_no'] = addUserFromData.phone != "" ? addUserFromData.phone : "";
            //tempHash["update"]['address'] = addUserFromData.address != "" ? addUserFromData.address.toString() : "";
            tempHash["update"]['status'] = addUserFromData.status ? 1 : 0;
            if (Object.keys(addUserFromData.profileImage).length > 0) {
                tempHash["update"]['profile_img'] = addUserFromData.profileImage
            }
        }
        return tempHash;
    }

    closeOrganizationModal = () => {
        const { t } = this.props
        this.setState({
            organizationModal: false,
            zoominzoomoutflag: "",
        }, () => {
            //console.log("organizationModal close", this.state.organizationModal)
            this.resetOrganizationFrom();
        })
    }

    resetOrganizationFrom = () => {
        this.setState({
            fromDataError: {
                "organization_name": "",
                "whatsapp_api_endpoint": "",
                "phone_number_id": "",
                "token": "",
                "marketed_by_name": "",
                "marketed_by_url": "",
                "selectedVersion": "",
                "contractStartDate": "",
                "contractEndDate": "",
                "facebook_app_id": "",
                "whatsapp_business_account_id": "",
                "delay_time": "",
                "secret_key": ""
            },
            addUserFromDataError: {
                "name": "",
                "email": ""
            },
            addUserInfoFromDataError: {
                "city": "",
                "country": "",
                "phone_no": "",
            },
            documentError: "",
            whatsappBusinessPhoneNumberError: "",
        })
    }

    /*resetOrganizationFrom = () => {
        this.setState({
            fromData: {
                "organization_name": "",
                "profileImage": "",
                "org_id": "",
                "whatsapp_api_endpoint": "",
                "phone_number_id": "",
                "token": "",
                "marketed_by_name": "",
                "marketed_by_url": "",
                "selectedVersion": [],
                "contractStartDate": "",
                "contractEndDate": "",
                "facebook_app_id": "",
                "whatsapp_business_account_id": "",
                "delay_time": "0.00"
            },
            fromDataError: {
                "organization_name": "",
                "whatsapp_api_endpoint": "",
                "phone_number_id": "",
                "token": "",
                "marketed_by_name": "",
                "marketed_by_url": "",
                "selectedVersion": "",
                "contractStartDate": "",
                "contractEndDate": "",
                "facebook_app_id": "",
                "whatsapp_business_account_id": "",
                "delay_time": ""
            },
            //orgDataEditFlag: false,
            imageEditFrom: "",

            addUserFromData: {
                "name": "",
                "email": "",
                //"phone": "",
                //"address": "",
                "profileImage": "",
                "status": true,
                "user_id": "",
            },
            // addUserInfoFromData: {
            //     "city": "",
            //     "country": "",
            //     "phone_no": "",
            // },
            addUserFromDataError: {
                "name": "",
                "email": ""
            },
            addUserInfoFromDataError: {
                "city": "",
                "country": "",
                "phone_no": "",
            },
            addprofileImageSelected: require('../../../Utility/Public/images/uploadicon.png'),
            addProfileImagePreviewShow: false,
            //saveButtonDisableEditModal: true,

            documentObjFileName: this.props.t('choosefile'),
            documentObjfileObj: "",
            documentError: "",
            handleChangeVersionFlag: false,
            freeTrialSubscription: false,
            monthlySubscription: false,
            yearlySubscription: false,
            whatsappBusinessPhoneNumberError: "",
            whatsappBusinessPhoneNumber: "",
            whatsappBusinessPhoneNumberNote: false
        })
    }*/

    //Image url crop 
    addInputProfileImageChanged = (event) => {

        let { fromData } = this.state;
        let targetFileSplit = event.target.files[0].name.split('.');
        let lastElement = targetFileSplit.pop();
        let user_profile_image = {
            "file_name": "",
            "file_obj": ""
        };
        if (lastElement == 'JPEG' || lastElement == 'jpeg' || lastElement == 'jpg' || lastElement == 'JPG' || lastElement == 'png' || lastElement == 'PNG' || lastElement == '') {
            const fsize = event.target.files[0].size;
            const file = Math.round((fsize / 1024));
            if (file >= 300) {
                Utility.toastNotifications("File is too Big, please select a file less than 300kb", "Warning", "warning");
            } else {
                this.setState({
                    imageCropModalFlag: true
                })
                if (event.target.files && event.target.files.length > 0) {
                    const reader = new FileReader();
                    reader.addEventListener('load', () =>
                        this.setState({ src: reader.result })
                    );
                    reader.readAsDataURL(event.target.files[0]);
                    user_profile_image["file_name"] = event.target.files[0].name
                    user_profile_image["file_obj"] = ""
                    fromData["profileImage"] = user_profile_image
                    this.setState({
                        fromData,
                        addProfileImagePreviewShow: true,
                        addProfileImageError: "",
                        //orgDataEditFlag: true,
                        imageEditFrom: "org",
                    })
                }
            }

        } else {
            fromData["profileImage"] = ""
            this.setState({
                fromData,
                addProfileImagePreviewShow: false,
                addprofileImageSelected: 'Add Image',
                //orgDataEditFlag: true,
            })
        }
    }

    onImageLoaded = (image) => {
        //console.log("onImageLoaded=====", image)
        this.imageRef = image;
    };

    onCropChange = (crop, percentCrop) => {
        // You could also use percentCrop:
        // this.setState({ crop: percentCrop });
        this.setState({ crop });
    };

    onCropComplete = (crop) => {
        this.makeClientCrop(crop, 'forOrgImage');
        this.setState({
            //saveButtonDisableEditModal: false
        })
    };

    onCropCompleteForUser = (crop) => {
        this.makeClientCrop(crop, 'forUserImage');
        this.setState({
            //saveButtonDisableEditModal: false
        })
    };

    async makeClientCrop(crop, callFrom) {
        const { fromData, addUserFromData } = this.state;
        if (this.imageRef && crop.width && crop.height) {
            const croppedImageUrl = await this.getCroppedImg(
                this.imageRef,
                crop,
                'newFile.jpeg'
            );
            let org_image = {}
            let add_user_image = {}
            if (callFrom == 'forOrgImage') {
                this.setState({
                    addprofileImageSelected: croppedImageUrl,
                })
                // for org image
                org_image["file_name"] = this.state.fromData.profileImage.file_name
                org_image["file_obj"] = this.state.addprofileImageSelected
                fromData["profileImage"] = org_image
            } else {
                this.setState({
                    addUserImageSelected: croppedImageUrl
                })
                // for user image
                add_user_image["file_name"] = this.state.addUserFromData.profileImage.file_name
                add_user_image["file_obj"] = this.state.addUserImageSelected
                addUserFromData["profileImage"] = add_user_image
            }
            this.setState({
                fromData,
                addUserFromData
            })


        }
    }

    getCroppedImg = (image, crop, fileName) => {
        const canvas = document.createElement('canvas');
        const pixelRatio = window.devicePixelRatio;
        const scaleX = image.naturalWidth / image.width;
        const scaleY = image.naturalHeight / image.height;
        const ctx = canvas.getContext('2d');

        canvas.width = crop.width * pixelRatio * scaleX;
        canvas.height = crop.height * pixelRatio * scaleY;

        ctx.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
        ctx.imageSmoothingQuality = 'high';

        ctx.drawImage(
            image,
            crop.x * scaleX,
            crop.y * scaleY,
            crop.width * scaleX,
            crop.height * scaleY,
            0,
            0,
            crop.width * scaleX,
            crop.height * scaleY
        );

        const base64Image = canvas.toDataURL('image/jpeg');
        return base64Image

    }

    imageCropDataSave = () => {
        this.setState({
            imageCropModalFlag: false
        })
    }
    //Image url crop

    imageCropModalShow = () => {
        this.setState({
            imageCropModalFlag: true
        })
    }

    imageCropModalHide = () => {
        const { fromData, addUserFromData } = this.state;
        fromData["profileImage"] = ""
        addUserFromData["profileImage"] = ""
        this.setState({
            imageCropModalFlag: false,

            // for org image
            addprofileImageSelected: require('../../../Utility/Public/images/profile-back.png'),
            addProfileImageError: "",
            fromData,
            addProfileImagePreviewShow: false,

            // for user image
            addUserImageSelected: require('../../../Utility/Public/images/profile-back.png'),
            addUserImageError: "",
            addUserFromData,
            addUserImagePreviewShow: false,
            //saveButtonDisableEditModal: true
        })
    }

    addUserFromDataChange = (event, type) => {
        const { addUserFromData, addUserFromDataError } = this.state
        let tempAddUserFromData = Object.assign({}, addUserFromData);
        let tempAddUserFromDataError = Object.assign({}, addUserFromDataError);


        if (type == "name") {
            if (event.target.value != "") {
                tempAddUserFromData['name'] = event.target.value;
                tempAddUserFromDataError['name'] = ""
            } else {
                tempAddUserFromData['name'] = "";
                tempAddUserFromDataError['name'] = "Required field";
            }
        }

        if (type == "email") {
            if (event.target.value != "") {
                tempAddUserFromData['email'] = event.target.value;
                tempAddUserFromDataError['email'] = ""
            } else {
                tempAddUserFromData['email'] = "";
                tempAddUserFromDataError['email'] = "Required field"
            }
        }

        /*if (type == "phone") {
            if (event.target.value != "") {
                let phoneValidate = HomeUtility.validate_Phone_Number(event.target.value);
                if (phoneValidate) {
                    tempAddUserFromData['phone'] = event.target.value;
                    tempAddUserFromDataError['phone'] = ""
                } else {
                    tempAddUserFromData['phone'] = event.target.value;
                    tempAddUserFromDataError['phone'] = this.props.t('validphonenumber')
                }
            } else {
                tempAddUserFromData['phone'] = "";
                tempAddUserFromDataError['phone'] = ""
            }
        }

        if (type == "address") {
            if (event.target.value != "") {
                tempAddUserFromData['address'] = event.target.value;
                tempAddUserFromDataError['address'] = ""
            } else {
                tempAddUserFromData['address'] = "";
                tempAddUserFromDataError['address'] = ""
            }
        }*/

        if (type == "status") {
            if (event.target.checked) {
                tempAddUserFromData['status'] = true;
                tempAddUserFromDataError['status'] = ""
            } else {
                tempAddUserFromData['status'] = false;
                tempAddUserFromDataError['status'] = ""
            }
        }

        this.setState({
            addUserFromData: tempAddUserFromData,
            addUserFromDataError: tempAddUserFromDataError,
            userDataEditFlag: true,
            //saveButtonDisableEditModal: false,

        })

    }

    addUserInfoFromDataChange = (event, type) => {
        const { addUserInfoFromData, addUserInfoFromDataError } = this.state
        let tempAddUserInfoFromData = Object.assign({}, addUserInfoFromData);
        let tempAddUserInfoFromDataError = Object.assign({}, addUserInfoFromDataError);

        if (type == "city") {
            if (event.target.value != "") {
                tempAddUserInfoFromData['city'] = event.target.value;
                tempAddUserInfoFromDataError['city'] = ""
            } else {
                tempAddUserInfoFromData['city'] = "";
                tempAddUserInfoFromDataError['city'] = ""
            }
        }
        if (type == "country") {
            if (event.target.value != "") {
                tempAddUserInfoFromData['country'] = event.target.value;
                tempAddUserInfoFromDataError['country'] = ""
            } else {
                tempAddUserInfoFromData['country'] = "";
                tempAddUserInfoFromDataError['country'] = ""
            }
        }
        if (type == "phone_no") {
            if (event.target.value != "") {
                tempAddUserInfoFromData['phone_no'] = event.target.value;;
                tempAddUserInfoFromDataError['phone_no'] = ""
            } else {
                tempAddUserInfoFromData['phone_no'] = "";
                tempAddUserInfoFromDataError['phone_no'] = ""
            }
        }
        this.setState({
            addUserInfoFromData: tempAddUserInfoFromData,
            addUserInfoFromDataError: tempAddUserInfoFromDataError,
            //saveButtonDisableEditModal: false
        }, () => {
            //console.log("addUserInfoFromData====",this.state.addUserInfoFromData)
        })


    }

    addUserImageChanged = (event) => {

        let { addUserFromData } = this.state;
        let targetFileSplit = event.target.files[0].name.split('.');
        let lastElement = targetFileSplit.pop();
        let user_profile_image = {
            "file_name": "",
            "file_obj": ""
        };
        if (lastElement == 'JPEG' || lastElement == 'jpeg' || lastElement == 'jpg' || lastElement == 'JPG' || lastElement == 'png' || lastElement == 'PNG' || lastElement == '') {
            const fsize = event.target.files[0].size;
            const file = Math.round((fsize / 1024));
            if (file >= 300) {
                Utility.toastNotifications("File is too Big, please select a file less than 300kb", "Warning", "warning");
            } else {
                this.setState({
                    imageCropModalFlag: true
                })
                if (event.target.files && event.target.files.length > 0) {
                    const reader = new FileReader();
                    reader.addEventListener('load', () =>
                        this.setState({ src: reader.result })
                    );
                    reader.readAsDataURL(event.target.files[0]);
                    user_profile_image["file_name"] = event.target.files[0].name
                    user_profile_image["file_obj"] = ""
                    addUserFromData["profileImage"] = user_profile_image
                    this.setState({
                        addUserFromData,
                        addUserImagePreviewShow: true,
                        addUserImageError: "",
                        userDataEditFlag: true,
                        imageEditFrom: "user"
                    })
                }
            }

        } else {
            addUserFromData["profileImage"] = ""

            this.setState({
                addUserFromData,
                addUserImagePreviewShow: false,
                addUserImageSelected: 'Add Image',
                addUserImageError: "Required field",
                userDataEditFlag: true
            })
        }
    }

    //file upload code start
    dropDocumentFileChange = (files, event) => {
        if (files.length == 1) {
            let fileName = files[0].name.split(".")
            let extension = fileName.pop()
            let marketed_by_logo_url = {
                "file_name": "",
                "file_obj": ""
            };
            if (extension.toLowerCase() == "jpg" || extension.toLowerCase() == "jpeg" || extension.toLowerCase() == "png") {
                const fsize = files[0].size;
                const file = Math.round((fsize / 1024));
                if (file >= 5120) {
                    Utility.toastNotifications(this.props.t('fileUploadAlert'), "Warning", "warning");
                } else {
                    this.getBase64MarketedLogoUrl(files[0], (result) => {
                        // user_profile_image["file_name"] = event.target.files[0].name
                        // user_profile_image["file_obj"] = ""
                        // fromData["profileImage"] = user_profile_image
                        let _hash = {}
                        _hash['file_name'] = files[0].name
                        _hash['file_obj'] = result
                        //console.log("_hash=======",_hash)
                        this.setState({
                            documentObjfileObj: _hash,
                            documentObjFileName: files[0].name,
                            documentError: "",
                            //saveButtonDisableEditModal: false,
                        }, () => {
                            // console.log("documentObjfileObj=========", this.state.documentObjfileObj)
                        })
                    })
                }
            } else {
                Utility.toastNotifications(this.props.t('fileTypeAlert'), "Warning", "warning");
            }
        } else {
            this.setState({
                documentObjfileObj: "",
                documentObjFileName: this.props.t('choosefile'),
                documentError: this.props.t('pleaseselectonefile'),
                documentError: "",
            })
        }
    }

    getBase64MarketedLogoUrl(file, cb) {
        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function () {
            cb(reader.result)
        };
        reader.onerror = function (error) {
            //console.log('Error: ', error);
        };
    }

    uploadDocumentFileChange = (event) => {
        if (event.target.files.length == 1) {
            let fileName = event.target.files[0].name.split(".")
            let extension = fileName.pop()
            if (extension.toLowerCase() == "jpg" || extension.toLowerCase() == "jpeg" || extension.toLowerCase() == "png") {
                const fsize = event.target.files[0].size;
                const file = Math.round((fsize / 1024));
                if (file >= 5120) {
                    Utility.toastNotifications(this.props.t('fileUploadAlert'), "Warning", "warning");
                } else {
                    this.getBase64MarketedLogoUrl(event.target.files[0], (result) => {
                        let _hash = {}
                        _hash['file_name'] = event.target.files[0].name
                        _hash['file_obj'] = result
                        //console.log("_hash=======",_hash)
                        this.setState({
                            documentObjfileObj: _hash,
                            documentObjFileName: event.target.files[0].name,
                            //saveButtonDisableEditModal: false,
                            //orgDataEditFlag: true,
                        }, () => {
                            //console.log("documentObjfileObj=========", this.state.documentObjfileObj)
                        })
                    })
                }
            } else {
                Utility.toastNotifications(this.props.t('fileTypeAlert'), "Warning", "warning");
            }
        } else {
            this.setState({
                documentObjfileObj: "",
                documentObjFileName: this.props.t('choosefile'),
                documentError: this.props.t('pleaseselectonefile'),
            })
        }
    }

    handleChangeVersionFn = (e) => {
        let fromDataTemp = Object.assign({}, this.state.fromData);
        let fromDataTempError = Object.assign({}, this.state.fromDataError);
        if (e.value == "") {

            fromDataTempError['selectedVersion'] = "Required field";
            fromDataTemp['selectedVersion'] = [];
            fromData
            this.setState({
                fromData: fromDataTemp,
                fromDataError: fromDataTempError
            }, () => {
            })
        } else {
            fromDataTempError['selectedVersion'] = "";
            fromDataTemp['selectedVersion'] = [e];
            this.setState({
                fromData: fromDataTemp,
                fromDataError: fromDataTempError,
                handleChangeVersionFlag: true
            }, () => {
            })
        }
    }

    formatDateInput = (type) => {
        const { fromData } = this.state;
        if (type == "contractEndDate") {
            // console.log(' fromData.contractEndDate.month==================>', (fromData.contractEndDate.month).toString().padStart(2, 0))

            if (fromData.contractEndDate == "") return '';
            const Year = fromData.contractEndDate.year.toString();
            const Month = fromData.contractEndDate.month.toString().padStart(2, 0);
            const Day = fromData.contractEndDate.day.toString().padStart(2, 0);
            const comboContractEndDate = `${Timezone.formatDate(Day + '/' + Month + '/' + Year, this.props.localTimeZoneName).split(" ")[0]} (${Timezone.getTimezoneName(this.props.localTimeZoneName)})`;
            // return `${Day}/${Month}/${Year}`;
            return comboContractEndDate;

        }
        if (type == "contractStartDate") {

            if (fromData.contractStartDate == "") return '';
            const Year = fromData.contractStartDate.year.toString();
            const Month = fromData.contractStartDate.month.toString().padStart(2, 0);
            const Day = fromData.contractStartDate.day.toString().padStart(2, 0);
            const comboContractStartDate = `${Timezone.formatDate(Day + '/' + Month + '/' + Year, this.props.localTimeZoneName).split(" ")[0]} (${Timezone.getTimezoneName(this.props.localTimeZoneName)})`;
            // return `${Day}/${Month}/${Year}`;
            return comboContractStartDate;

        }
    };

    handleChangeContractDate = (type, date) => {
        const { fromData, fromDataError } = this.state;
        if (type == "contractStartDate") {
            let fromDataTemp = Object.assign({}, fromData);
            let fromDataTempError = Object.assign({}, fromDataError);
            if (date == "") {
                fromDataTemp['contractStartDate'] = "";
                fromDataTemp['contractEndDate'] = "";
            } else {
                fromDataTemp['contractStartDate'] = date;
                fromDataTemp['contractEndDate'] = "";
                fromDataTempError['contractStartDate'] = "";

            }
            this.setState({
                fromData: fromDataTemp,
                fromDataError: fromDataTempError,
                freeTrialSubscription: false,
                monthlySubscription: false,
                yearlySubscription: false
            }, () => {
                // console.log('fromData===============>', fromData)
            })
        }
        if (type == "contractEndDate") {
            let fromDataTemp = Object.assign({}, fromData);
            let fromDataTempError = Object.assign({}, fromDataError);
            if (date == "") {
                fromDataTemp['contractEndDate'] = "";
            } else {
                fromDataTemp['contractEndDate'] = date;

                fromDataTempError['contractEndDate'] = "";
            }
            this.setState({
                fromData: fromDataTemp,
                fromDataError: fromDataTempError,
                freeTrialSubscription: false,
                monthlySubscription: false,
                yearlySubscription: false
            }, () => {
                // console.log('fromData===============>', fromData)
            })
        }
    }


    handleChangeSubscriptionChange = (event, type) => {
        let fromDataTemp = Object.assign({}, this.state.fromData);
        let fromDataErrorTemp = Object.assign({}, this.state.fromDataError);

        const { checked } = event.target;

        let formattedStartContractDate = "";
        let tempcontract_start_date = new Date();

        let formattedEndContractDate = "";
        let tempcontract_end_date = new Date();

        if (type == "freeTrial") {
            if (checked) {
                tempcontract_end_date.setDate(tempcontract_end_date.getDate() + 15);

                formattedStartContractDate = {
                    year: tempcontract_start_date.getFullYear(),
                    month: tempcontract_start_date.getMonth() + 1,
                    day: tempcontract_start_date.getDate(),
                }
                formattedEndContractDate = {
                    year: tempcontract_end_date.getFullYear(),
                    month: tempcontract_end_date.getMonth() + 1,
                    day: tempcontract_end_date.getDate(),
                }
                fromDataTemp = {
                    ...fromDataTemp, "contractStartDate": formattedStartContractDate,
                    "contractEndDate": formattedEndContractDate
                }
                fromDataErrorTemp = {
                    ...fromDataErrorTemp, "contractStartDate": "",
                    "contractEndDate": ""
                }
                this.setState({
                    freeTrialSubscription: checked,
                    monthlySubscription: false,
                    yearlySubscription: false,
                    fromData: fromDataTemp,
                    fromDataError: fromDataErrorTemp
                })
            } else {
                fromDataTemp = {
                    ...fromDataTemp, "contractStartDate": "",
                    "contractEndDate": ""
                }
                this.setState({
                    freeTrialSubscription: false,
                    monthlySubscription: false,
                    yearlySubscription: false,
                    fromData: fromDataTemp
                })
            }
        }
        if (type == "monthly") {
            if (checked) {
                tempcontract_end_date.setMonth(tempcontract_end_date.getMonth() + 1);

                formattedStartContractDate = {
                    year: tempcontract_start_date.getFullYear(),
                    month: tempcontract_start_date.getMonth() + 1,
                    day: tempcontract_start_date.getDate(),
                }
                formattedEndContractDate = {
                    year: tempcontract_end_date.getFullYear(),
                    month: tempcontract_end_date.getMonth() + 1,
                    day: tempcontract_end_date.getDate(),
                }
                fromDataTemp = {
                    ...fromDataTemp, "contractStartDate": formattedStartContractDate,
                    "contractEndDate": formattedEndContractDate
                }
                fromDataErrorTemp = {
                    ...fromDataErrorTemp, "contractStartDate": "",
                    "contractEndDate": ""
                }
                this.setState({
                    freeTrialSubscription: false,
                    monthlySubscription: checked,
                    yearlySubscription: false,
                    fromData: fromDataTemp,
                    fromDataError: fromDataErrorTemp
                })
            } else {
                fromDataTemp = {
                    ...fromDataTemp, "contractStartDate": "",
                    "contractEndDate": ""
                }
                this.setState({
                    freeTrialSubscription: false,
                    monthlySubscription: false,
                    yearlySubscription: false,
                    fromData: fromDataTemp
                })
            }
        }
        if (type == "yearly") {
            if (checked) {
                tempcontract_end_date.setFullYear(tempcontract_end_date.getFullYear() + 1);

                formattedStartContractDate = {
                    year: tempcontract_start_date.getFullYear(),
                    month: tempcontract_start_date.getMonth() + 1,
                    day: tempcontract_start_date.getDate(),
                }
                formattedEndContractDate = {
                    year: tempcontract_end_date.getFullYear(),
                    month: tempcontract_end_date.getMonth() + 1,
                    day: tempcontract_end_date.getDate(),
                }
                fromDataTemp = {
                    ...fromDataTemp, "contractStartDate": formattedStartContractDate,
                    "contractEndDate": formattedEndContractDate
                }
                fromDataErrorTemp = {
                    ...fromDataErrorTemp, "contractStartDate": "",
                    "contractEndDate": ""
                }
                this.setState({
                    freeTrialSubscription: false,
                    monthlySubscription: false,
                    yearlySubscription: checked,
                    fromData: fromDataTemp,
                    fromDataError: fromDataErrorTemp
                })
            } else {
                fromDataTemp = {
                    ...fromDataTemp, "contractStartDate": "",
                    "contractEndDate": ""
                }
                this.setState({
                    freeTrialSubscription: false,
                    monthlySubscription: false,
                    yearlySubscription: false,
                    fromData: fromDataTemp
                })
            }
        }
    }

    whatsappBusinessPhoneNumberInputHandleChangeFn = (phone_number) => {
        const { whatsappBusinessPhoneNumber } = this.state;

        let whatsappBusinessPhoneNumberTemp = whatsappBusinessPhoneNumber
        if (phone_number != "") {
            let phoneValidate = HomeUtility.validate_Phone_Number_without_plus(phone_number);
            // console.log("phoneValidate======", phoneValidate)
            if (phoneValidate) {
                whatsappBusinessPhoneNumberTemp = phone_number;
                this.setState({
                    // handleChangeUserInformationPhoneNumberFlag: true,
                    whatsappBusinessPhoneNumberError: ""
                })
            } else {
                whatsappBusinessPhoneNumberTemp = phone_number;
                this.setState({
                    // handleChangeUserInformationPhoneNumberFlag: true,
                    whatsappBusinessPhoneNumberError: "Enter valid phone number"
                })
            }
        } else {
            whatsappBusinessPhoneNumberTemp = "";
            this.setState({
                // handleChangeUserInformationPhoneNumberFlag: true,
                // phoneNumberError: "Enter a phone number"
            })
        }
        this.setState({
            whatsappBusinessPhoneNumber: Config.phoneNumberWithOrwithoutPlus + '' + whatsappBusinessPhoneNumberTemp
        }, () => {
            // console.log("whatsappBusinessPhoneNumber===", this.state.whatsappBusinessPhoneNumber);
        })
    }

    handleChangeActiveOrgNoteFn = () => {
        let whatsappBusinessPhoneNumberNoteTemp = this.state.whatsappBusinessPhoneNumberNote;
        this.setState({
            whatsappBusinessPhoneNumberNote: !whatsappBusinessPhoneNumberNoteTemp
        })
    }

    downloadeSecreteKey = (data) => {
        let orgsecret_key = data.secret_key;
        let base64String = btoa(orgsecret_key);
        let finalBase64 = base64String;
        let orgName = data.organization_name;
        this.downloadTextFile(finalBase64, orgName);
    }

    downloadTextFile = (finalBase64, orgName) => {
        let base64String = finalBase64;

        // Create a Blob with the Base64 string and set its type to plain text
        const blob = new Blob([base64String], { type: 'text/plain' });

        // Create a URL for the Blob
        const url = URL.createObjectURL(blob);

        // Create a temporary anchor element
        const anchor = document.createElement('a');
        anchor.href = url;
        anchor.download = orgName + "-" + "secret-key.txt"; // Set the desired file name

        // Programmatically click the anchor to trigger download
        document.body.appendChild(anchor);
        anchor.click();

        // Clean up by removing the temporary anchor and revoking the Blob URL
        document.body.removeChild(anchor);
        URL.revokeObjectURL(url);
    };

    render() {
        let roleName = this.props.userCredentials.hasOwnProperty('user_details') && this.props.userCredentials.user_details && this.props.userCredentials.user_details.hasOwnProperty('user_type') && this.props.userCredentials.user_details.user_type
        return (
            <div className="gridcontainer" style={{ marginBottom: "2%" }}>
                <div className='col-md-12'>
                    <div className='row'>
                        <div className="accountinfo_block">
                            <AccountInfoContent
                                //Image crop
                                addInputProfileImageChanged={this.addInputProfileImageChanged}
                                addprofileImageSelected={this.state.addprofileImageSelected}
                                crop={this.state.crop}
                                croppedImageUrl={this.state.croppedImageUrl}
                                src={this.state.src}
                                onImageLoaded={this.onImageLoaded}
                                onCropComplete={this.onCropComplete}
                                onCropChange={this.onCropChange}
                                imageCropModalShow={this.imageCropModalShow}
                                imageCropModalHide={this.imageCropModalHide}
                                imageCropModalFlag={this.state.imageCropModalFlag}
                                imageCropDataSave={this.imageCropDataSave}
                                closeOrganizationModal={this.closeOrganizationModal}

                                //form data
                                handelChange={this.handelChange}
                                fromData={this.state.fromData}
                                fromDataError={this.state.fromDataError}
                                statusList={this.state.statusList}
                                addCustomer={this.addCustomer}
                                addProfileImagePreviewShow={this.state.addProfileImagePreviewShow}

                                //Add user From Data for Edit
                                addUserImageSelected={this.state.addUserImageSelected}
                                addEditUser={this.addEditUser}
                                addUserFromDataChange={this.addUserFromDataChange}
                                addUserFromData={this.state.addUserFromData}
                                addUserFromDataError={this.state.addUserFromDataError}
                                addUserImageError={this.state.addUserImageError}
                                addUserImageChanged={this.addUserImageChanged}

                                //orgDataEditFlag={this.state.orgDataEditFlag}
                                userDataEditFlag={this.state.userDataEditFlag}

                                onCropCompleteForUser={this.onCropCompleteForUser}
                                imageEditFrom={this.state.imageEditFrom}
                                addUserImagePreviewShow={this.state.addUserImagePreviewShow}
                                //saveButtonDisableEditModal={this.state.saveButtonDisableEditModal}

                                addUserInfoFromDataError={this.state.addUserInfoFromDataError}
                                addUserInfoFromData={this.state.addUserInfoFromData}
                                addUserInfoFromDataChange={this.addUserInfoFromDataChange}
                                dropDocumentFileChange={this.dropDocumentFileChange}
                                uploadDocumentFileChange={this.uploadDocumentFileChange}
                                documentObjFileName={this.state.documentObjFileName}
                                documentError={this.state.documentError}
                                versionOption={this.state.versionOption}
                                handleChangeVersionFn={this.handleChangeVersionFn}
                                handleChangeContractDate={this.handleChangeContractDate}
                                formatDateInput={this.formatDateInput}

                                freeTrialSubscription={this.state.freeTrialSubscription}
                                monthlySubscription={this.state.monthlySubscription}
                                yearlySubscription={this.state.yearlySubscription}
                                handleChangeSubscriptionChange={this.handleChangeSubscriptionChange}

                                whatsappBusinessPhoneNumber={this.state.whatsappBusinessPhoneNumber}
                                whatsappBusinessPhoneNumberError={this.state.whatsappBusinessPhoneNumberError}
                                whatsappBusinessPhoneNumberInputHandleChangeFn={this.whatsappBusinessPhoneNumberInputHandleChangeFn}

                                handleChangeActiveOrgNoteFn={this.handleChangeActiveOrgNoteFn}
                                whatsappBusinessPhoneNumberNote={this.state.whatsappBusinessPhoneNumberNote}

                                downloadeSecreteKey={this.downloadeSecreteKey}
                                valueEdited={this.state.valueEdited}
                            />
                        </div >
                    </div >
                </div >
            </div >
        );
    }
}


const mapStateToProps = (globalState) => {
    return {
        userCredentials: globalState.LoginReducer.userCredentials,
        roleWisePermission: globalState.mainReducerData.roleWisePermission,
        version: globalState.LoginReducer.version,
        localTimeZoneName: globalState.mainReducerData.localTimeZone
    };
}

export default withRouter(connect(mapStateToProps, { loaderStateTrue, loaderStateFalse, setToken, setUserCredentials, logOutApp })
    (withTranslation()(AccountInfo)));